import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import Typo from 'consts/typography';
import { onChangeAuthPage } from 'features/home/homeSlice';
import useUserDetail from 'hooks/useUserDetail';
import React from 'react';
import { platformStates } from 'redux/platformSlice';

interface BetFormMainTabProps {
  currentTab: number;
  changeTab: (tab: number) => void;
}

const BetFormMainTab: React.FunctionComponent<BetFormMainTabProps> = (props) => {
  const { currentTab, changeTab } = props;
  const { isUserLoggedIn } = useUserDetail();
  const t = useAppTranslation();
  const { isPhone, isTablet, isDesktop } = useAppSelector(platformStates);
  const platform = useAppSelector(platformStates);

  const dispatch = useAppDispatch();

  const onChangeTab = (tabId: number) => {
    if (tabId === 2 && !isUserLoggedIn) {
      dispatch(onChangeAuthPage(0));
      return;
    }
    changeTab(tabId);
  };
  return (
    <div className="w-full flex flex-row items-center main-tab">
      <button
        className={`flex-1 h-full cursor-pointer font-bold ${currentTab === 1 && 'tab__active'} ${
          isPhone ? Typo.p5 : isTablet ? Typo.p3 : isDesktop ? Typo.p6 : Typo.p1
        }`}
        onClick={() => onChangeTab(1)}
      >
        {t('betFormMainTab.betSlip')}
      </button>
      <button
        className={`flex-1 h-full cursor-pointer font-bold ${currentTab === 2 && 'tab__active'} ${
          isPhone ? Typo.p5 : isTablet ? Typo.p3 : isDesktop ? Typo.p6 : Typo.p1
        }`}
        onClick={() => onChangeTab(2)}
      >
        {t('betFormMainTab.myBets')}
      </button>
    </div>
  );
};

export default BetFormMainTab;
